<div class="property-card" [class.hover-enabled]="!disableHoverEffects">
  <div class="property-card-image">
    <img
      src="{{ details?.image }}"
      alt=""
      class="card-image w-100"
      yp-e2e-id="similar-property-image"
    />
  </div>
  <div class="property-card-description">
    <div class="property-card-description-price">
      <span class="property-price" yp-e2e-id="similar-property-price">{{
        details?.price | gbpCurrency
      }}</span>
    </div>
    <span
      class="property-card-description-heading"
      yp-e2e-id="similar-property-address"
      >{{ details?.address }}</span
    >
  </div>
</div>
